import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/fair";




class FairService {

  editfair(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addfair(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  fairExist(label:string, id : number){
    return axios
      .post(API_URL + '/exist', {label: label, id : id})
      .then(response => {
        return response.data;
      });
  }

  deletefair(fairId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+fairId)
      .then(response => {
        return response.data;
      });
  }

  


  getfairs(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

    getfairlookups() {
    return axios
      .get(API_URL + "/fair-lookups" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }


 

}

export default new FairService();